/* eslint-disable */
const pluralize = (value: number, words: string[]): string =>
  words[
    value % 100 > 4 && value % 100 < 20
      ? 2
      : [2, 0, 1, 1, 1, 2][value % 10 < 5 ? value % 10 : 5]
  ];

export default pluralize;
